import React from 'react'
import './Aboutpage.css'

function Aboutpage() {
    return (
        <div className="aboutpage-container">
            {/* Hero Section */}
            <div className="hero-section">
                <div className="hero-content">
                    <h1 className="hero-title">
                        What is <span className="gradient-text">Wait Times Ontario</span>?
                    </h1>
                    <p className="hero-subtitle">
                        We empower patients and health professionals with diagnostic imaging wait time predictions across Ontario, Canada to get you the quickest scan.
                    </p>
                </div>
            </div>

            {/* Main Content */}
            <div className="content-section">
                <div className="feature-grid">
                    <div className="feature-card">
                        <div className="feature-icon">⚡</div>
                        <h3>Find the Fastest Scan</h3>
                        <p>Compare wait times across all imaging centres in Ontario to find the facility with the shortest wait time for your scan type.</p>
                    </div>

                    <div className="feature-card">
                        <div className="feature-icon">📍</div>
                        <h3>Find Nearest Facilities</h3>
                        <p>Discover the closest imaging centres with the shortest wait times. Search by location or sort by distance to find the best option for your needs.</p>
                    </div>

                    <div className="feature-card">
                        <div className="feature-icon">
                            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="8" y="6" width="32" height="38" rx="2" fill="#2d2d2d" stroke="#4a4a4a" stroke-width="1.5"/>
                                <rect x="12" y="12" width="24" height="8" rx="1" fill="#1a1a1a"/>
                                <rect x="14" y="24" width="6" height="5" rx="1" fill="#4A90E2"/>
                                <rect x="22" y="24" width="6" height="5" rx="1" fill="#4A90E2"/>
                                <rect x="30" y="24" width="6" height="5" rx="1" fill="#4A90E2"/>
                                <rect x="14" y="31" width="6" height="5" rx="1" fill="#4A90E2"/>
                                <rect x="22" y="31" width="6" height="5" rx="1" fill="#4A90E2"/>
                                <rect x="30" y="31" width="6" height="5" rx="1" fill="#4A90E2"/>
                                <rect x="14" y="38" width="14" height="5" rx="1" fill="#4A90E2"/>
                            </svg>
                        </div>
                        <h3>Smart Calculations</h3>
                        <p>We take into account imaging centre reported wait times for outpatient scans and reviews from actual patients to best predict the current wait times.</p>
                    </div>
                </div>

                <div className="info-section">
                    <h2>How It Works</h2>
                    <div className="steps-container">
                        <div className="step">
                            <div className="step-number">1</div>
                            <div className="step-content">
                                <h4>Browse Wait Times</h4>
                                <p>View comprehensive wait time data for MRI and CT scans across Ontario hospitals.</p>
                            </div>
                        </div>
                        <div className="step">
                            <div className="step-number">2</div>
                            <div className="step-content">
                                <h4>Search & Filter</h4>
                                <p>Search by hospital name or location, and filter by wait time or distance from your location.</p>
                            </div>
                        </div>
                        <div className="step">
                            <div className="step-number">3</div>
                            <div className="step-content">
                                <h4>Make Informed Decisions</h4>
                                <p>Compare wait times and distances to choose the best imaging centre for your needs.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mission-section">
                    <h2>Our Mission</h2>
                    <p className="mission-text">
                        Wait Times Ontario is dedicated to improving healthcare accessibility by providing transparent, 
                        easy-to-access information about diagnostic imaging wait times. We believe that patients deserve 
                        to make informed decisions about their healthcare, and our platform empowers you to find the 
                        best options available.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Aboutpage